module.exports = __webpack_public_path__ + "img/ic_32_profile_benachrichtigungen.264455ce.svg";